import React from "react";
import Chip from "@material-ui/core/Chip";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";
import ConfirmToast from "components/ConfirmToast";
import { toast } from "react-toastify";
import { Tooltip } from "@material-ui/core";

const SingleTag = (props) => {
  const { item, onDeleteTag } = props;
  function handleDelete() {
    toast.info(
      <ConfirmToast
        message="Do you want to delete this tag?"
        confirm={confirmDelete}
      />
    );
  }
  function confirmDelete() {
    //delete
    onDeleteTag(item);
  }
  const handleClick = () => {
    console.info("You clicked the Chip.");
  };

  return (
    <Tooltip title={item.description ? item.description : ""} enterDelay={300}>
      <Chip
        className="mr-2"
        label={item.tag}
        onClick={handleClick}
        onDelete={handleDelete}
        deleteIcon={<CloseIcon />}
        color={"primary"}
        size="sm"
        style={
          item.colour
            ? { backgroundColor: item.colour, color: "#fff" }
            : undefined
        }
      />
    </Tooltip>
  );
};
export default SingleTag;
